// extracted by css-extract-rspack-plugin
export default {"contentsHead":"Create__contentsHead--s7496","contentsHeadButtonWrap":"Create__contentsHeadButtonWrap--oerVY"};